/**
* @name: record-header
* @author: weiyong
* @date: 2024-06-16 21:06
* @description：record-header
* @update: 2024-06-16 21:06
*/
<template>
  <div class="record-content flex-div" :style="[elCtlStyle,elSty]">
    <a-card @click="cardClick(record)"
            :size="props.size"
            class="w100b"
            :style="[elBaseStyle]"
            :hoverable="props.hoverable"
            :bordered="props.bordered">

      <template v-for="(column,index) in dataConfig.contentCols">
        <div class="time-line-cell flex-div flex-div-bet">

          <div v-if="!flowDealFlag" class="grid-cell-ctl-show">
            <grid-cell-ctl-show
                :index="index"
                :column="column"
                :record="record"/>
          </div>

          <div  v-show="flowDealFlag" class="flex-1" style="flex:1">
            {{ record.operationContent||record.operation }}
          </div>

        </div>

        <template v-if="column&&(column.dataIndex === 'operation'||column.propType === 'operation')">
          <table-operation-show
              :record="record"
              :rowIndex="index"
              :column="column"></table-operation-show>
        </template>
      </template>

    </a-card>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  components: {},
  name: "record-content",
});
</script>

<script lang="ts" setup>
import TableOperationShow from "@/main-page/commonVue/table-operation-show.vue";
import GridCellCtlShow from "@/main-page/gridCellCtlShow/index.vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {Card as ACard} from 'ant-design-vue';


interface propTypes {
  flowDealFlag:boolean;
  record:any,
  props: any,
  styles: any,
  dataConfig: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  record:{},
  flowDealFlag:false,
  styles: {},
  props: {},
  dataConfig:{}
});

const {props, styles}: any = toRefs(propsPage);

const {elCtlStyle, elBaseStyle} = useCtlStyle({
  styles,
  props,
  propsStyl:['width'],
  outExtendProp:[]
});

const elSty=computed(()=>{
  const sty={};
  if(unref(props)['width']==='auto'||(unref(props)['width']+'').indexOf("%")>0){
    sty['width']=unref(props)['width'];
  }else{
    sty['width']=unref(props)['width']+'px';
  }
  return sty;
})

const emits=defineEmits(['cardClick'])
const cardClick=function (item){
  emits('cardClick',{item})
}
</script>

<style type="text/css" lang="less">
.xmTimeLine.xmTimeLine-commonList{
  .record-content{
    margin-bottom: 6px;
  }
  .pramaryColor{
    background-color:var(--primary-color,rgb(0, 167, 111));
    color:#FFF;
  }
  .notOkColor{
    background-color:#f00;
    color:#FFF;
  }
}
</style>
